import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { BiCalendar } from 'react-icons/bi';
import { FaFileInvoiceDollar } from 'react-icons/fa';
import { FiFileText } from 'react-icons/fi';
import Skeleton from 'react-loading-skeleton';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import formatPrice from '../../services/utils/formatPrice';
import { setAgreementStatus } from '../../store/agreement/actions';
import { navigationUrl } from '../../store/analytic/actions';
import { setContractInformations } from '../../store/contract/actions';
import { page } from '../../store/auth/actions';
import getContractDescription from '../../utils/getContractDescription';
import { getContractsFromList } from '../../utils/getContractsToShow';
import getOriginalContract from '../../utils/getOriginalContract';
import {
  CardContainer,
  Container,
  ContractDescription,
  Subtitle,
  Title,
  Wrapper,
} from './styles';
import { agreementStatusForDebts, statusNameChange } from './constants';

const Agreement: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { agreementDebtLoading, list, contractsLoading } = useSelector(
    (state: ApplicationState) => ({
      list: state.agreement.list,
      agreementDebtLoading: state.agreement.agreementDebtLoading,
      contractsLoading: state.contract.contractsLoading,
    })
  );
  const [agreementsFiltered, setAgreementsFiltered] = useState<
    GQL.IDeal[] | undefined
  >(undefined);

  useEffect(() => {
    setAgreementsFiltered(
      list.filter(
        (agreement) => !agreementStatusForDebts.includes(agreement.status)
      )
    );
  }, [list]);

  const contractsToShow = useMemo(() => getContractsFromList(list), [list]);
  useEffect(() => {
    dispatch(page('acordo'));
    dispatch(
      navigationUrl.request({
        action: '/visualizouAcordos',
      })
    );
  }, [dispatch]);
  useEffect(() => {
    dispatch(setContractInformations(null));
  }, [dispatch]);
  const handlerDeal = (agreement: GQL.IDeal) => {
    dispatch(
      setContractInformations({
        databaseId: agreement.databaseId,
        creditorId: agreement.creditorId,
      })
    );

    dispatch(setAgreementStatus(agreement.status));
    history.push({ pathname: '/parcela-acordo', state: { agreement } });
  };

  return (
    <>
      {agreementDebtLoading || contractsLoading ? (
        <>
          <Wrapper>
            <Skeleton className='title' />
            <Skeleton className='subtitle' />
            <Skeleton className='contract' />
            <Skeleton className='contract' />
          </Wrapper>
        </>
      ) : (
        <>
          {agreementsFiltered && agreementsFiltered.length > 0 ? (
            <Wrapper>
              <Container>
                <Title>Meus Acordos</Title>
                <Subtitle>
                  Selecione um acordo abaixo para ver mais detalhes
                </Subtitle>
                {agreementsFiltered.map((agreement, index) => (
                  <CardContainer
                    key={index}
                    onClick={() => handlerDeal(agreement)}
                  >
                    <div className='row'>
                      <div className='left'>
                        <p className='portion'>
                          <FaFileInvoiceDollar
                            id='icon'
                            style={{ height: 14 }}
                          />{' '}
                          Parcela atual{' '}
                          {`(${agreement.portion}/${agreement.plan})`}: R$
                          {formatPrice(agreement.portionValue ?? 0)}
                          {/* {formatPrice(agreement.portionValue)} */}
                        </p>
                        <p className='default'>
                          <BiCalendar style={{ height: 14 }} /> Vencimento
                          parcela atual{' '}
                          <strong style={{ fontSize: 14 }}>
                            {moment(agreement.portionDueDate).format(
                              'DD/MM/YYYY'
                            )}
                          </strong>
                        </p>
                        <p className='default'>
                          <FiFileText style={{ height: 14, marginRight: 4 }} />
                          {agreement.contracts?.length > 1
                            ? `Múltiplos contratos`
                            : `Contrato: `}
                          {agreement.contracts?.length === 1 && (
                            <strong>
                              {contractsToShow &&
                                getOriginalContract(contractsToShow[index][0])}
                            </strong>
                          )}
                        </p>

                        <p className='default'>
                          <FiFileText style={{ height: 14, marginRight: 4 }} />
                          Status:
                          <strong>
                            {' '}
                            {statusNameChange[agreement.status] ??
                              agreement.status}
                          </strong>
                        </p>
                      </div>
                      <div className='right'>
                        <p className='text'>Valor total:</p>
                        <p className='price'>
                          <span>Valor total: </span>R${' '}
                          {formatPrice(agreement.totalPlanValue ?? 0)}
                        </p>
                        <p className='bank'>{agreement.creditorName}</p>
                      </div>
                    </div>

                    {contractsToShow?.length === 1 ? (
                      <ContractDescription>
                        {getContractDescription(contractsToShow[index][0])}
                      </ContractDescription>
                    ) : (
                      <></>
                    )}
                  </CardContainer>
                ))}
              </Container>
            </Wrapper>
          ) : (
            <Wrapper>
              <Container>
                <Title>Meus Acordos</Title>
                <Subtitle>Não há acordos disponíveis</Subtitle>
              </Container>
            </Wrapper>
          )}
        </>
      )}
    </>
  );
};

export default Agreement;
